import { Box, IconButton } from "@mui/material";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@mui/icons-material";

type Props = {
  edit?: boolean;
  disabled?: boolean;
  handleEdit?: () => void;
  handleSubmit: () => void;
  handleReset: () => void;
}

export function FormEditActions({ edit = true, disabled = false, handleEdit, handleSubmit, handleReset }: Props) {
  return edit ? (
    <Box display="flex" gap={1}>
      <IconButton
        onClick={handleSubmit}
        disabled={disabled}
        color="success"
      >
        <CheckOutlined />
      </IconButton>
      <IconButton
        onClick={handleReset}
        disabled={disabled}
        color="error"
      >
        <CloseOutlined />
      </IconButton>
    </Box>
  ) : (
    <IconButton onClick={handleEdit} disabled={disabled}>
      <EditOutlined />
    </IconButton>
  )
}